import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaClipboardCheck, FaMapMarkerAlt, FaEye,
    FaUserShield, FaCalendarAlt, FaStore, FaImages, FaInfoCircle
} from "react-icons/fa";

export default function VisitsPage() {
    const location = useLocation();
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [visits, setVisits] = useState([]);

    const query = new URLSearchParams(location.search);

    const truncateWords = (text, limit) => {
        if (!text) return "---";
        const words = text.split(" ");
        return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
    };

    useEffect(() => {
        const fetchVisits = async () => {
            setLoading(true);
            try {
                let data = [];

                // التحقق من المعاملات المرسلة في الرابط
                const establishmentId = query.get("establishment");
                const type = query.get("type");
                const inspector = query.get("inspector");
                const staffName = query.get("staffName"); // القيمة الجديدة القادمة من صفحة الموظفين

                if (establishmentId) {
                    data = await backEnd_request.get(`/InspectionVisits/by-establishment/${establishmentId}`).then(r => r.data);
                } else if (type) {
                    data = await backEnd_request.get(`/InspectionVisits/by-type?type=${type}`).then(r => r.data);
                } else if (inspector) {
                    data = await backEnd_request.get(`/InspectionVisits/by-inspector?inspectorName=${inspector}`).then(r => r.data);
                } else if (staffName) {
                    // الربط البرمجي: جلب الزيارات بناءً على اسم الموظف الثلاثي
                    data = await backEnd_request.get(`/InspectionVisits/by-inspector?inspectorName=${staffName}`).then(r => r.data);
                } else {
                    data = await backEnd_request.get(`/InspectionVisits`).then(r => r.data);
                }
                console.log(data);
                setVisits(Array.isArray(data) ? data : [data]);
            } catch (err) {
                console.error("Error fetching visits:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchVisits();
    }, [location.search]); // تحديث البيانات عند تغير الرابط

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl">
            <div className="container-fluid px-4">

                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded-3 shadow-sm border-end border-primary border-5">
                    <div>
                        <h4 className="fw-bold text-dark m-0">
                            <FaClipboardCheck className="ms-2 text-primary" />
                            {query.get("staffName") ? `زيارات المفتش: ${query.get("staffName")}` : "سجل الزيارات"}
                        </h4>
                        <small className="text-muted">إجمالي الزيارات المسجلة: {visits.length}</small>
                    </div>
                    <button onClick={() => navigate(-1)} className="btn btn-outline-dark btn-sm rounded-pill px-4">رجوع</button>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : (
                    <div className="table-responsive custom-table-container">
                        <table className="table table-hover align-middle main-modern-table">
                            <thead>
                                <tr>
                                    <th>المنشأة</th>
                                    <th>نوع الزيارة</th>
                                    <th>المفتش المسؤول</th>
                                    <th>تقرير الزيارة</th>
                                    <th>الموقع الجغرافي</th>
                                    <th>التاريخ والوقت</th>
                                    <th className="text-center">التفاصيل</th>
                                </tr>
                            </thead>
                            <tbody>
                                {visits.map((v) => (
                                    <tr key={v.visitUid} className="table-row-item">
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <div className="bg-soft-primary p-2 rounded-2 ms-2">
                                                    <FaStore className="text-primary" />
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark small">{v.establishment?.name || "غير معروف"}</div>
                                                    <div className="x-small text-muted">ID: {v.visitId}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <span className={`badge ${v.visitType === 'تموينية' ? 'bg-info' : 'bg-secondary'} fw-normal`}>
                                                {v.visitType}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="small fw-bold"><FaUserShield className="ms-1 text-muted" /> {v.inspector1Name || "---"}</div>
                                            <div className="x-small text-muted">ودورية مراقبة</div>
                                        </td>
                                        <td style={{ maxWidth: '200px' }}>
                                            <div className="d-flex align-items-start gap-1">
                                                <FaInfoCircle className="text-muted mt-1 x-small" />
                                                <div className="x-small text-dark italic">
                                                    {truncateWords(v.visitReport, 8)}
                                                </div>
                                            </div>
                                            {v.photos?.length > 0 && (
                                                <div className="mt-1 x-small text-primary"><FaImages className="ms-1" /> {v.photos.length} صور مرفقة</div>
                                            )}
                                        </td>
                                        <td>
                                            <div className="small fw-bold">{v.governorate || "---"}</div>
                                            <div className="x-small text-muted"><FaMapMarkerAlt className="ms-1" />{v.district || "---"}</div>
                                        </td>
                                        <td>
                                            <div className="small fw-bold text-dark">
                                                <FaCalendarAlt className="ms-1 text-info" />
                                                {v.visitDate?.split("T")[0]}
                                            </div>
                                            <div className="x-small text-muted">{v.visitTime?.slice(0, 5)}</div>
                                        </td>
                                        <td className="text-center">
                                            <button
                                                className="action-btn view mx-auto"
                                                onClick={() => navigate(`/admin/visit-details/${v.visitUid}`)}
                                            >
                                                <FaEye />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {visits.length === 0 && (
                            <div className="text-center py-5 bg-white rounded-3 shadow-sm mt-3 text-muted">
                                لا توجد زيارات مسجلة لهذا البحث
                            </div>
                        )}
                    </div>
                )}
            </div>

            <style>{`
                .x-small { font-size: 0.75rem; }
                .bg-soft-primary { background-color: #e7f1ff; }
                .main-modern-table { border-collapse: separate; border-spacing: 0 12px; }
                .main-modern-table thead th { border: none; color: #6c757d; font-size: 0.8rem; text-transform: uppercase; padding: 0 15px; }
                
                .table-row-item { background-color: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.04); border-radius: 12px; transition: all 0.3s; }
                .table-row-item td { padding: 12px 15px; border: none; }
                
                .table-row-item td:first-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; border-right: 5px solid #0d6efd; }
                .table-row-item td:last-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }

                .table-row-item:hover { transform: scale(1.005); box-shadow: 0 4px 15px rgba(0,0,0,0.08); background-color: #f8f9ff !important; }

                .action-btn.view { 
                    width: 38px; height: 38px; border-radius: 50%; border: none;
                    background: #212529; color: #fff; display: flex; align-items: center; justify-content: center;
                    transition: 0.2s;
                }
                .action-btn.view:hover { background: #0d6efd; transform: rotate(15deg); }
            `}</style>
        </div>
    );
}